export const CREATE_SA_QUERY_GROUP_NAME = "create_search_analytics_query_group";
export const CREATE_SA_QUERY_GROUP_DESC = `Creates a Query Group under a Search Analytics project.

Use when the user wants to add a query grouping for Search Analytics. If only projectId is provided, the tool resolves the corresponding Search Analytics ID automatically.

Input (one of "projectId" or "searchAnalyticsId" is required):
- "projectId": Search Analytics Project ID. The tool resolves the Search Analytics ID.
- "searchAnalyticsId": Search Analytics ID directly.
- "name" (required): Query Group name.
- "op" (required): Logical operator (AND|OR).
- "patterns" (required): Array of { type, pattern }.
  - type must be one of: INCLUDES, STARTS_WITH, ENDS_WITH, EQUALS, REGEX, NOT_INCLUDES, CONTAINS, NOT_CONTAINS, NOT_REGEX.
- Optional: description, prepend (boolean, defaults false).

Notes:
- Be forgiving: trim blanks, drop duplicates, and convert CSV/TSV/line lists into pattern objects. Default type = CONTAINS unless the row starts with a known type followed by a separator (comma/tab/space).
- If intent is unclear, prefer AND for safer grouping while respecting explicit user input.
- Normalize patterns by trimming quotes/spaces only; avoid altering core strings. If a row looks like a full query, keep it as-is.
- When the user pastes many rules, batch them into a single patterns array.
- Write operation (mutation). Returns created Query Group fields plus resolved projectId and searchAnalyticsId.`;
